import "./rightbar.css"
import { ConnectionState } from '../../socket/ConnectionState';

export default function Rightbar() {
  return (
    <div className="rightbar">
      <div className="rightbarWrapper">
        Connectionstate
      </div>
    </div>
  )
}